import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '@shared/api/client';
import qs from 'qs';

const FIELDS = ['businessName', 'customIdentifier', 'address'];

export const fetchAccounts = createAsyncThunk(
  'accounts/fetchAccounts',
  async (_, { rejectWithValue }) => {
    try {
      const response = await client.get(`/accounts${qs.stringify({ fields: FIELDS.join() }, {
        addQueryPrefix: true,
      })}`);

      if (response.ok) {
        return { ok: true, data: response.data };
      }

      return rejectWithValue({
        error: response.data?.message || 'Failed to load accounts',
        status: response.status,
      });
    } catch (error) {
      return rejectWithValue({
        error: typeof error === 'string' ? error : 'Network error',
        status: null,
      });
    }
  },
);